var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { OrganizationModel } from '../../organizations/models/organization.model';
var ɵ0 = function () { return OrganizationModel; };
var UserProfileModel = /** @class */ (function () {
    function UserProfileModel() {
    }
    __decorate([
        Type(ɵ0),
        __metadata("design:type", Array)
    ], UserProfileModel.prototype, "organizations", void 0);
    return UserProfileModel;
}());
export { UserProfileModel };
export { ɵ0 };
